export const RaSimpleShowLayoutStyles = {
    styleOverrides: {
        root: {
            padding: 0,
        },
    },
};
